export default "__VITE_ASSET__CQNXY7mo__"